import { render, staticRenderFns } from "./JcdcImg.vue?vue&type=template&id=3a3f06c2&scoped=true"
import script from "./JcdcImg.vue?vue&type=script&lang=ts"
export * from "./JcdcImg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3f06c2",
  null
  
)

export default component.exports